import { Divider, styled } from '@mui/material'
import { useId } from 'react'
import { ROW_PADDING_INLINE } from './NavItem'
import { NAV_ITEM_GAP, NavList } from './NavList'
import { useSideNavContext } from './SideNavContext'
import type { ReactNode } from 'react'

type NavSectionProps = {
  title: string
  /** The section's `NavItem`s. */
  children: ReactNode
}

const Title = styled('span')(({ theme }) => ({
  display: 'block',
  marginBottom: NAV_ITEM_GAP,
  ...theme.typography['small-medium'],
  color: theme.palette.text.muted,
  padding: theme.spacing(1.5, ROW_PADDING_INLINE),
}))

/** A titled run of `NavItem`s, e.g. a settings area such as Account or Organisation. */
export const NavSection = ({ title, children }: NavSectionProps) => {
  const titleId = useId()

  return (
    <li>
      <Title id={titleId}>{title}</Title>
      <NavList aria-labelledby={titleId}>{children}</NavList>
    </li>
  )
}

const Line = styled(Divider, { shouldForwardProp: (prop) => prop !== 'collapsed' })<{ collapsed: boolean }>(
  ({ theme, collapsed }) => ({
    flexShrink: 0,
    // The list's own gap already sits on either side of the line.
    margin: `calc(${theme.spacing(3)} - ${NAV_ITEM_GAP}) ${theme.spacing(collapsed ? 0.5 : 2)}`,
  })
)

/** Separates runs of `NavItem`s, or `NavSection`s. */
export const NavDivider = () => {
  const { collapsed } = useSideNavContext()
  return (
    <li>
      <Line collapsed={collapsed} />
    </li>
  )
}
